import { render, staticRenderFns } from "./ReInputMask.vue?vue&type=template&id=1242b1d0&scoped=true"
import script from "./ReInputMask.vue?vue&type=script&lang=js"
export * from "./ReInputMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242b1d0",
  null
  
)

export default component.exports